import React from 'react';
import { ENVIRONMENT_BANNER } from 'constants';
import './environment_banner.scss';

const EnvironmentBanner = () => {
  if (!ENVIRONMENT_BANNER) {
    return null;
  }
  return <div className="environment-banner">{ENVIRONMENT_BANNER}</div>;
};

export default EnvironmentBanner;
